export const OrderSummaryComponent = {
    template: `
        <div class="order-summary-wrapper" ng-if="!$ctrl.isLoading">
            <div class="action-buttons" ng-class="{'pickup-offset': !$ctrl.isDelivery()}" ng-transclude></div>
            <p c-type="title-md-primary" ng-class="{'pickup-offset': !$ctrl.isDelivery()}">{{$ctrl.cartDisplayService.getFormattedDisplayData()}}</p>
            <p c-type="body-md-primary">{{$ctrl.deliveryString()}}</p>
        </div>
    `,
    transclude: true,
    controller: class {
        constructor(cartDisplayService, cartService, orderInfoService, ORDER_TYPES) {
            'ngInject';

            Object.assign(this, {
                cartDisplayService,
                cartService,
                orderInfoService,
                ORDER_TYPES,
            });

            this.cartDisplay = cartDisplayService.displayData;
            this.isLoading = true;

            cartDisplayService.getDisplayData()
                .finally(() => this.isLoading = false);
        }

        deliveryString() {
            if (this.cartService.hasWarnings()) {
                return '';
            }

            const orderInfo = this.orderInfoService.getDeliveryInfo();
            if(this.isDelivery()) return orderInfo.address1;
            return '';
        }

        isDelivery() {
            return this.cartDisplay.diningOption === this.ORDER_TYPES.DELIVERY;
        }
    }
};
